// extracted by mini-css-extract-plugin
module.exports = {"groupHeader":"table_groupHeader__1meEM"};